module.exports = __webpack_public_path__ + "img/plan3.6f97f2bc.png";